import React from 'react';
import { connect } from 'react-redux';

import Button from '../../components/basic/Button';
import Dialog from 'material-ui/Dialog';

import { MODALS } from '../../constants/Constants';
import * as modalActions from '../../actions/ModalActions';
import * as companyActions from '../../actions/entities/CompanyActions';

const Modal = ({ open, data, closeModal, deleteCompany }) => {
  const handleClose = () => closeModal(MODALS.COMPANY_DELETE);
  const actions = [
    <Button label="Cancel" onClick={handleClose} />,
    <Button
      secondary
      label="Delete"
      raised
      onClick={() => {
        deleteCompany(data.id);
        handleClose();
      }}
    />
  ];
  return (
    <Dialog
      actions={actions}
      modal={false}
      open={open}
      onRequestClose={handleClose}
      contentStyle={{ minWidth: '200px', maxWidth: '500px' }}
    >
      Do you want to delete the company <b>{data.name}</b>?
    </Dialog>
  );
};

const mapStateToProps = ({ modals }) => ({
  ...modals[MODALS.COMPANY_DELETE]
});

export default connect(mapStateToProps, { ...modalActions, ...companyActions })(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/CompanyDeleteModal.js